<template>
    <v-container fluid>
        <product-form
            :model="this.product"
            @saved="saved"
            v-if="this.product"
            class="mb-5 pa-2"
        />
    </v-container>
</template>

<script>
import Product from '@/models/product/Product'
import Form from './Form'
export default {
    components: {
        'product-form': Form,
    },

    props: ['id'],

    data: () => {
        return {
            product: null,
        }
    },

    computed: {
        model() {
            return new Product()
        },
    },

    methods: {
        async getProduct() {
            let item = await this.model.find(this.id)
            this.product = item
        },

        saved() {
            this.$router.go(-1)
        },
    },

    created() {
        this.getProduct()
    },
}
</script>

<style></style>
